let Admin = {
  themes: {
    default: { class: "bg-admin-default", color: '#818cf8', permission: 'administrador' },
    gerente: { class: "bg-admin-gerente", color: '#38bdf8', permission: 'gerente' },
    logistica: { class: "bg-admin-logistica", color: '#60a5fa', permission: 'logistica' },
    supervisor: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'supervisor' },
    vendedor: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'operacao' },
    operacao: { class: "bg-admin-default", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'operacao' },
    parceiro: { class: "bg-admin-vendedor", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'parceiro' },
    atendente: { class: "bg-admin-default", color: `${process.env.REACT_APP_SELLER_COLOR}`, permission: 'atendente' },

  },

  items: [
    {
      section: "Geral",
      options: [
        {
          icon: "dashboard",
          text: "Dashboard",
          link: "/admin",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'parceiro', 'supervisor'],
        },
        {
          icon: "people",
          text: "Clientes",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor'],
        },
        {
          icon: "shopping_cart",
          text: "Reservas",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'parceiro', 'supervisor'],
        },
        {
          icon: "receipt_long",
          text: "Orçamentos",
          permission: ['administrador', 'gerente', 'operacao', 'supervisor'],
        },
        {
          icon: "calendar_today",
          text: "Cupos",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor', 'atendente'],
          
        },
        {
          icon: "departure_board",
          text: "Saídas",
          permission: ['administrador', 'gerente', 'logistica'],
        },
      ]
    },
    {
      section: "Administrar",
      permission: ['administrador', 'gerente', 'logistica'],
      options: [
        {
          icon: "monetization_on_icon",
          text: "Fluxo de Caixa",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "pending_actions",
          text: "Aprovações",
          permission: ['administrador'],
        },
        {
          id: "central",
          icon: "chat",
          text: "Central",
          dropdown: true,
          children: [
            {
              name: 'Mensagens',
            },
            {
              name: 'Templates',
            },
            {
              name: 'Tipos',
            }
          ],
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "map",
          text: "Regiões",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "photo_camera",
          text: "Passeios",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "flight",
          text: "Traslados",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "card_travel",
          text: "Combos",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: 'directions_bus_filled',
          text: 'Veículos',
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "storefront",
          text: "Vendedores",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "accessibility",
          text: "Motoristas",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "person_search",
          text: "Guias",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          id: "partners",
          icon: "assignment_ind",
          text: "Parceiros",
          dropdown: true,
          children: [
            {
              name: 'Agências',
            },
            {
              name: 'Vendedores',
            }
          ],
          permission: ['administrador', 'gerente'],
        },
      ]
    },
    {
      section: "Relatórios",
      permission: ['administrador', 'gerente'],
      options: [
        {
          icon: "percent",
          text: "Comissões",
        },
      ]
    },
    {
      section: "Suporte",
      options: [
        {
          icon: "confirmation_number",
          text: "Tickets",
          link: "/admin/tickets",
          permission: ['administrador', 'gerente', 'logistica', 'operacao', 'supervisor', 'vendedor', 'atendente'],
        },
        {
          icon: "star",
          text: "Satisfação (CSAT)",
          link: "/admin/tickets/csat",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "emoji_emotions",
          text: "Satisfação Clientes",
          link: "/admin/satisfacao-clientes",
          permission: ['administrador', 'gerente', 'logistica'],
        },
        {
          icon: "campaign",
          text: "Broadcast App",
          link: "/admin/broadcast-app",
          permission: ['administrador', 'gerente'],
        },
        {
          icon: "local_offer",
          text: "Promoções FT App",
          link: "/admin/promo-app",
          permission: ['administrador', 'gerente'],
        },
      ]
    }
  ]
};

export default Admin;